import React, { Component } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Map, ImageOverlay, Popup, Polygon } from "react-leaflet";

import history from "../component/history";
import booth from "../image/icon/booth.png";
import floormap from "../image/floormap/MapnamaBBAF2colorized.jpg";
import marker from "../component/marker";

class Floor extends Component {
  customPin = L.divIcon({
    className: "location-pin",
    html: `<img src=${booth}><div class="pin"></div><div class="pulse"></div>`,
    iconSize: [40, 40],
    iconAnchor: [24, 40],
  });

  constructor(props) {
    super(props);

    const iniBounds = L.latLngBounds(null, null);

    this.state = {
      isReady: false,
      width: window.innerWidth,
      height: window.innerHeight,
      pathColor: "purple",
      currentZoomLevel: 1,
      bounds: iniBounds,
      targetFloor: "delta_f1",
      floors: {
        name: "F1",
        image: floormap,
        markers: marker.markerArray,
      },
      disable: false,
    };
  }

  componentDidMount() {
    this.getStand();
    const map = this.map.leafletElement;

    map.on("zoomend", () => {
      const updatedZoomLevel = map.getZoom();
      this.handleZoomLevelChange(updatedZoomLevel);
    });

    map.on("click", (e) => {
      // this.handleAddMarker(e, map);
    });

    const w = 3522,
      h = 2507;

    const southWest = map.unproject([0, h], map.getMaxZoom() - 1);
    const northEast = map.unproject([w, 0], map.getMaxZoom() - 1);

    const bounds = new L.LatLngBounds(southWest, northEast);
    this.setState({ bounds: bounds });
    map.setMaxBounds(bounds);
    this.setState({ isReady: true });
  }

  getStand() {
    fetch("http://management.batikbordirfair.com/api/get_stand", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Authorization":
          "knWzcX6kP1qbSdIjFian5vJ8BTDk2koZ70HfS5TB13uM0znX4BitAh8tIwCkxyrN",
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.state.floors.markers.forEach((o) => {
          responseJson.result.forEach((o2) => {
            if (o.id_stand === +o2.id_stand) {
              o.nama_stand = o2.nama_stand;
            }
          });
        });
      })
      .catch((error) => console.log("parsing failed", error));
  }

  handleZoomLevelChange(newZoomLevel) {
    this.setState({ currentZoomLevel: newZoomLevel });
  }

  handleAddMarker(e, map) {
    // const cid = util.datetick();

    // add Marker to state
    // let _floors = Object.assign({}, this.state.floors);
    // _floors.markers = [..._floors.markers, _marker];

    // this.setState({
    //   floors: _floors,
    // });
    console.log(e.latlng);
  }

  updatePolygonColor1(e) {
    let updatedMarkers = this.state.floors.markers.map((m) => {
      if (!m.active) {
        e.target.openPopup();
      }
      if (m.id_stand === e.target.options.id) {
        m.active = true;
      }
      return m;
    });
    this.setState({ markers: updatedMarkers });
  }

  updatePolygonColor2(e) {
    let updatedMarkers = this.state.floors.markers.map((m) => {
      if (!m.active) {
        e.target.closePopup();
      }
      if (m.id_stand === e.target.options.id) {
        m.active = false;
      }
      return m;
    });
    this.setState({ markers: updatedMarkers });
  }

  onClickPolygon1(e) {
    let updatedMarkers = this.state.floors.markers.map((m) => {
      if (m.id_stand === e.target.options.id) {
        m.active = true;
      }
      return m;
    });
    this.setState({ markers: updatedMarkers, disable: true });
  }

  onClickPolygon2(e) {
    let updatedMarkers = this.state.floors.markers.map((m) => {
      if (m.id_stand === e.target.options.id) {
        m.active = false;
      }
      return m;
    });
    this.setState({ markers: updatedMarkers, disable: false });
  }

  onClick = (m) => {
    const convert = m.nama_stand.replace(/ /g, "_").toLowerCase();
    history.push(`/${convert}&${m.id_stand}/`);
  };

  render() {
    return (
      <div className="App">
        <Map
          ref={(m) => {
            this.map = m;
          }}
          center={[0, 0]}
          zoom={1}
          minZoom={1}
          maxZoom={4}
          crs={L.CRS.Simple}
          attributionControl={false}
        >
          <ImageOverlay
            url={this.state.floors.image}
            bounds={this.state.bounds}
          >
            {this.state.isReady &&
              this.state.floors.markers.map((m) => (
                <Polygon
                  key={m.id_stand}
                  id={m.id_stand}
                  fillColor={m.active ? "blue" : "#fcf803"}
                  fillOpacity={0.5}
                  weight={0}
                  color={"white"}
                  positions={m.polygon}
                  onclick={this.onClickPolygon1.bind(this)}
                  onpopupclose={this.onClickPolygon2.bind(this)}
                  onMouseOver={
                    this.state.disable
                      ? null
                      : this.updatePolygonColor1.bind(this)
                  }
                  onMouseOut={
                    this.state.disable
                      ? null
                      : this.updatePolygonColor2.bind(this)
                  }
                >
                  <Popup minWidth={90}>
                    <span
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {m.number} <br />
                      {m.nama_stand} <br />
                      <button
                        class="button button1"
                        style={{ marginTop: 10 }}
                        type="button"
                        onClick={() => this.onClick(m)}
                      >
                        {m.id_stand === 666
                          ? "Rundown Acara"
                          : "Kunjungi Stand"}
                      </button>
                    </span>
                  </Popup>
                </Polygon>
              ))}
          </ImageOverlay>
        </Map>
      </div>
    );
  }
}

export default Floor;



// WEBPACK FOOTER //
// ./src/Home/Floor.js